var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { SuggestionField } from './SuggestionField';
import { useSuggestionEditor } from '@hooks';
import { PlaintextCellEditor } from './PlaintextCellEditor';
import React, { useCallback, useRef, useState } from 'react';
export const SuggestPlaintextCellEditor = (_a) => {
    var { autodocType, isReadOnly, isSalesforce, onSave, sonarObjectId, value } = _a, rest = __rest(_a, ["autodocType", "isReadOnly", "isSalesforce", "onSave", "sonarObjectId", "value"]);
    const editorRef = useRef(null);
    const [editingValue, setEditingValue] = useState('');
    const suggestion = useSuggestionEditor({
        autodocType,
        isReadOnly,
        sonarObjectId,
        value
    });
    const onEdit = useCallback(() => {
        var _a;
        suggestion.accept();
        (_a = editorRef.current) === null || _a === void 0 ? void 0 : _a.edit();
    }, [suggestion]);
    const onAccept = useCallback(() => {
        var _a;
        suggestion.accept();
        (_a = editorRef.current) === null || _a === void 0 ? void 0 : _a.save();
    }, [suggestion]);
    const onFocus = useCallback(() => {
        suggestion.accept();
    }, [suggestion]);
    const onBlur = useCallback(() => {
        const userInput = !suggestion.value && editingValue;
        if (!(suggestion.value && suggestion.accepted) && !userInput) {
            suggestion.reset();
        }
    }, [editingValue, suggestion]);
    const onChange = useCallback((newValue) => {
        setEditingValue(newValue);
    }, []);
    const handleSave = useCallback((newValue) => __awaiter(void 0, void 0, void 0, function* () {
        const result = onSave(newValue);
        if (result === null || result === void 0 ? void 0 : result.then) {
            yield result;
        }
        suggestion.reset();
    }), [onSave, suggestion]);
    return (React.createElement(SuggestionField, { autodocType: autodocType, isReadOnly: isReadOnly, isSpreadsheet: true, onAccept: onAccept, onBlur: onBlur, onEdit: onEdit, suggestion: suggestion },
        React.createElement(PlaintextCellEditor, Object.assign({}, rest, { isReadOnly: isReadOnly, isSalesforce: isSalesforce, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onSave: handleSave, ref: editorRef, value: suggestion.editorValue }))));
};
